import { LensTheme } from '@diligentcorp/atlas-theme-mui-lens';
import SearchIcon from '@mui/icons-material/Search';
import {
  InputAdornment,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
  useTheme,
} from '@mui/material';
import React from 'react';
import { CaseStatus } from '../../utils';

interface DeletedSanitizedCasesFiltersProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  typeFilter: string;
  onTypeFilterChange: (value: string) => void;
  countryFilter: string;
  onCountryFilterChange: (value: string) => void;
  countries: string[];
}

export const DeletedSanitizedCasesFilters: React.FC<
  DeletedSanitizedCasesFiltersProps
> = ({
  searchQuery,
  onSearchChange,
  typeFilter,
  onTypeFilterChange,
  countryFilter,
  onCountryFilterChange,
  countries,
}) => {
  const { tokens } = useTheme<LensTheme>();

  return (
    <Stack
      direction="row"
      sx={{
        gap: tokens.core.spacing[3].value,
        mt: tokens.core.spacing[3].value,
        mb: tokens.core.spacing[3].value,
        flexWrap: 'wrap',
      }}
    >
      <Stack
        sx={{
          gap: tokens.core.spacing['0_5'].value,
          flexGrow: 1,
          flexBasis: 0,
        }}
      >
        <Typography variant="caption">Search</Typography>
        <TextField
          size="small"
          placeholder="Search by"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />
      </Stack>

      <Stack
        sx={{
          gap: tokens.core.spacing['0_5'].value,
          flexGrow: 1,
          flexBasis: 0,
        }}
      >
        <Typography variant="caption">Filter by type</Typography>
        <Select
          displayEmpty
          value={typeFilter}
          onChange={(e) => onTypeFilterChange(e.target.value)}
          size="small"
          renderValue={(v) => (v ? v : 'Choose an option')}
        >
          <MenuItem value="">Choose an option</MenuItem>
          <MenuItem value={CaseStatus.SANITIZED}>Sanitized</MenuItem>
          <MenuItem value={CaseStatus.DELETED}>Deleted</MenuItem>
        </Select>
      </Stack>

      <Stack
        sx={{
          gap: tokens.core.spacing['0_5'].value,
          flexGrow: 1,
          flexBasis: 0,
        }}
      >
        <Typography variant="caption">Filter by country</Typography>
        <Select
          displayEmpty
          value={countryFilter}
          onChange={(e) => onCountryFilterChange(e.target.value)}
          size="small"
          renderValue={(v) => (v ? String(v) : 'Choose an option')}
        >
          <MenuItem value="">Choose an option</MenuItem>
          {countries.map((country: string) => (
            <MenuItem key={country} value={country}>
              {country}
            </MenuItem>
          ))}
        </Select>
      </Stack>
    </Stack>
  );
};
